import { useContext } from "react";
import { Navbar, NavbarBrand, Image, Collapse } from "react-bootstrap";
import NavbarToggle from "react-bootstrap/esm/NavbarToggle";
import { Link } from "react-router-dom";
import { ProfileContext } from "./Auth/ProfileProvider";
import { NavItems } from "./NavItems";
import { abpnClient } from "../Services/AbpnClient";

export default function NavMenu() {

    const { user } = useContext(ProfileContext);
    const isErrorPage = window.location.pathname == abpnClient._errorPage;

    return (
        <header>
            <Navbar className="bg-pp-secondary border-bottom box-shadow d-flex justify-content-between navbar-dark">
                <div>
                    <NavbarBrand as={Link} to="/" className="text-light ml-3">
                        <Image style={{ height: "40px" }} src="/physicianportal/ABPNlogoWhiteStacked.png" title="American Board of Psychiatry and Neurology, Inc." />
                    </NavbarBrand>
                </div>
                <div className="d-flex align-items-center justify-content-end">
                    {user && !isErrorPage && <div className="text-light mr-2 text-right pp-nav-text">
                        {user.fullName}
                        <br />
                        ABPN ID: {user.isOtherBoardPhysician ? user.otherBoardPhysicianCode : user.physicianId}
                    </div>
                    }
                    <NavbarToggle><span className="navbar-toggler-icon text-light"></span></NavbarToggle>
                    <Collapse>
                        <NavItems>
                        </NavItems>
                    </Collapse>
                </div>
            </Navbar>
        </header >
    );
}
